import { Injectable } from '@angular/core';
import RxDB, {
  RxDatabase
} from 'rxdb';
import '@babel/polyfill';
import * as pouchIdb from 'pouchdb-adapter-idb';
import { FormlySchemaCollection, formlySchemaCollection } from '../rxdb-schema/formly.schema';
import { DataSchemaCollection, dataSchemaCollection } from '../rxdb-schema/data.schema';
import { ApsAssignedCollection, apsAssignedCollection } from '../rxdb-schema/aps-assigned.schema';
import * as moment from 'moment';
import { authenticationCollection, AuthenticationSchemaCollection } from '../rxdb-schema/authentication.schema';
RxDB.plugin(pouchIdb);

interface APSDatabaseCollections {
  formly_schema: FormlySchemaCollection;
  form_data: DataSchemaCollection;
  aps_assigned_list: ApsAssignedCollection;
  auth: AuthenticationSchemaCollection;
}

type APSDatabase = RxDatabase<APSDatabaseCollections>;

const collections = [dataSchemaCollection, apsAssignedCollection, authenticationCollection];
let DB_INSTANCE: APSDatabase;
let dumpData: any;

async function createDB() {
  const db = await RxDB.create<APSDatabaseCollections>({
      name: `apsdb`,
      adapter: 'idb',
      queryChangeDetection: true,
      ignoreDuplicate: true,
      multiInstance: true,
      password: 'ic9baWrSJZsxdHTdVDoe3QzqpxcnNAsEb2MhYwpBFmg='
  });
  (window as any).db = db; // write to window for debugging

  // show leadership in title
  db.waitForLeadership()
  .then(() => {
      console.log('isLeader now');
      document.title = '♛ ' + document.title;
  });

  await Promise.all(collections.map(colData => db.collection(colData)));

  if (dumpData !== undefined) {
    db.importDump(dumpData);
  }

  return db;
}


export async function initDatabase() {
  console.log('run');
  if (localStorage.getItem('visitDate') !== null) {
    if (localStorage.getItem('visitDate') !== moment().format('MM-DD-YYYY')) {
      localStorage.setItem('visitDate', moment().format('MM-DD-YYYY'));
      await createDB();
      if (RxDB.isRxDatabase((window as any).db)) {
        (window as any).db.dump().then(data => {
          dumpData = data;
        });
      }
      await RxDB.removeDatabase('apsdb', 'idb');
    }
  } else {
    await RxDB.removeDatabase('apsdb', 'idb');
    localStorage.setItem('visitDate', moment().format('MM-DD-YYYY'));
  }
  DB_INSTANCE = await createDB();
}

@Injectable({
  providedIn: 'root'
})
export class RxdbService {
  constructor() {}

  get db(): APSDatabase {
    return DB_INSTANCE;
  }
}
